package com.xtream.data_kmp.db.dao

import androidx.paging.PagingSource
import androidx.room3.Dao
import androidx.room3.Query
import androidx.room3.Transaction
import com.xtream.data_kmp.db.tables.LiveCategoryWithVisibleStatus
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveCategoryWithSize
import com.xtream.data_kmp.dto.liveCategoriesTable

import kotlinx.coroutines.flow.Flow


@Dao
abstract class LiveCategoriesDao:RoomBaseInterface<LiveCategory> {
    @Query("""
    SELECT c.* FROM ${liveCategoriesTable} c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId AND h.type = 'LIVE'
    WHERE h.categoryId IS NULL
    ORDER BY c.created_at
""")
    abstract override fun allAsFlow(): Flow<List<LiveCategory>>

    @Query("""
    SELECT c.* FROM ${liveCategoriesTable} c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId AND h.type = 'LIVE'
    WHERE h.categoryId IS NULL
    ORDER BY c.created_at
""")
    abstract override fun allAsPagingSource(): PagingSource<Int, LiveCategory>

    @Transaction
    @Query("""
    SELECT 
        category.*, 
        COUNT(stream.streamId) AS size  
    FROM liveCategoriesTable AS category
    LEFT JOIN liveStreamsTable AS stream
        ON stream.categoryId = category.categoryId
    LEFT JOIN hidden_categories h
        ON category.categoryId = h.categoryId AND h.type = 'LIVE'
    WHERE h.categoryId IS NULL
    GROUP BY category.categoryId
    ORDER BY category.created_at
""")
    abstract fun getPagingCategoriesWithSize(): PagingSource<Int, LiveCategoryWithSize>

    @Query("""
    SELECT c.* FROM ${liveCategoriesTable} c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId AND h.type = 'LIVE'
    WHERE h.categoryId IS NULL
    ORDER BY c.created_at
""")
    abstract fun getPagedCategories(): PagingSource<Int, LiveCategory>







    /*
    @Query("SELECT * FROM $vodCategoriesTable WHERE uid IN (:userIds)")
    fun loadAllByIds(userIds: IntArray): List<VodCategory>
*/
    @Query("SELECT * FROM liveCategoriesTable WHERE (categoryId = :categoryId) LIMIT 1")
   abstract suspend fun getCategory(categoryId: Int): LiveCategory?

    @Query("SELECT EXISTS (SELECT 1 FROM ${liveCategoriesTable} WHERE categoryId = :id)")

    abstract override suspend fun hasEntity(id:Int):Boolean

    @Query("SELECT EXISTS (SELECT 1 FROM ${liveCategoriesTable} WHERE categoryId = :id)")

    abstract override fun hasEntityAsFlow(id:Int?):Flow<Boolean>

    @Query("SELECT COUNT(*) FROM ${liveCategoriesTable}")
    abstract override suspend fun getSize(): Long?
    @Query("DELETE FROM liveCategoriesTable")
    abstract override suspend fun deleteAll()

    @Query("""
    SELECT c.*,
           CASE WHEN h.categoryId IS NULL THEN 0 ELSE 1 END AS isHidden
    FROM liveCategoriesTable c
    LEFT JOIN hidden_categories h
        ON c.categoryId = h.categoryId
       AND h.type = 'LIVE'
""")
    abstract fun getCategoriesWithVisibleStatus():
            Flow<List<LiveCategoryWithVisibleStatus>>

}